import { render, staticRenderFns } from "./menu-book.vue?vue&type=template&id=4b85e577&scoped=true"
import script from "./menu-book.vue?vue&type=script&lang=js"
export * from "./menu-book.vue?vue&type=script&lang=js"
import style0 from "./menu-book.vue?vue&type=style&index=0&id=4b85e577&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b85e577",
  null
  
)

export default component.exports